import React from 'react'
import { Icon, Color } from '@cobalt/cobalt-react-components'
import {
  CHECK_EMAIL_TITLE,
  CHECK_EMAIL_MESSAGE
} from '../../constants/ui.labels'
import { ContentHeader } from '../../components'

const CheckEmail = () => (
  <div className="co--align-center vertical-space bottom-space">
    <Icon name={Icon.MAIL_OUTLINE} large color={Color.primary[600]} />
    <ContentHeader title={CHECK_EMAIL_TITLE} message={CHECK_EMAIL_MESSAGE} />
  </div>
)

export default CheckEmail
